import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, share, shareReplay } from 'rxjs/operators';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Dictionary } from 'lodash';
import { LockerCancellationCompanyResponse } from '../models/locker-cancellation-company-response.model';
import { deserialize } from '../../utils/json-typescript-mapper';

@Injectable({
    providedIn: 'root'
})
export class LockerCancellationDialogService {

    constructor(
        private http: HttpClient
    ) { }

    public getCompanyCustomMessage(messageCodes: string[]): Observable<Dictionary<string>> {
        return this.http.post<Dictionary<string>>(`${environment.corepfmapi}/company/CompanyCustomMessage`, messageCodes)
        .pipe(
            catchError((error: HttpErrorResponse) => { 
                return observableThrowError(error); 
            }),
            shareReplay(1)
        );
    }

    public getCompanyHostCustomMessageForLoginPage(messageCodes: string[]): Observable<LockerCancellationCompanyResponse> {
        const request = {
            host: window.location.host,
            messageCodes: messageCodes
        };

        return this.http.post<LockerCancellationCompanyResponse>(`${environment.corepfmapi}/company/LockerCancellationMessageForCompanyHost`, request)  // eslint-disable-line max-len
                .pipe(
/*                     map((res) => deserialize(LockerCancellationCompanyResponse, res)), */
                    catchError((error: HttpErrorResponse) => { 
                        return observableThrowError(error); 
                    }),
                    shareReplay(1)
                );
    }
}
